import { REQUEST_METHODS } from '@/constants';
import { request } from '@umijs/max';
import type { IAnnotatedTask, ITags } from './type';
import { message } from 'antd';

const publishStatusMap = {
  publish: 1,
  unpublish: 0,
} as const;
export const publishTemplate = async (data: {
  /** 0 下架 1 上架 */
  status: keyof typeof publishStatusMap;
  template_code: string;
}) => {
  try {
    const res = await request('/supertext-java/templates/status', {
      method: 'PUT',
      data: {
        status: publishStatusMap[data.status],
        template_code: data.template_code,
      },
      ignoreError: true,
    });
    return res;
  } catch (error) {
    // @ts-ignore
    message?.error({
      // @ts-ignore
      content: error?.msg,
      style: { marginTop: '30px' },
    });
    throw error;
  }
};

export const getTags = (templateCode: string, signal?: AbortSignal) => {
  return request<IRes<ITags>>(
    `/supertext-java/extraction/template/tags/${templateCode}`,
    { signal },
  );
};

getTags.queryKey = {
  method: 'GET',
  url: '/supertext-java/extraction/template/tags/templateCode',
};

/** 创建抽取点 */
export const createTags = (payload: { template_code: string; tags: ITags }) => {
  return request<IRes<ITags>>('/supertext-java/extraction/template/tags', {
    method: REQUEST_METHODS.post,
    data: payload,
  });
};

/** 删除抽取点 */
export const removeTags = (
  payload:
    | {
        template_code: string;
        table_code: string;
        tag_code: string;
      }
    | {
        template_code: string;
        table_code: string;
      }
    | {
        template_code: string;
        tag_code: string;
      },
) => {
  return request<IRes<any>>('/supertext-java/extraction/template/tags', {
    method: 'DELETE',
    data: payload,
  });
};

export const getAnnotatedList = (
  templateCode: string,
  signal?: AbortSignal,
) => {
  return request<IRes<IAnnotatedTask[]>>(
    `/supertext-java/extraction/template/nlp/annotation/task/list/${templateCode}`,
    { signal },
  );
};
getAnnotatedList.getQueryKey = () => {
  return {
    queryKey: [
      {
        method: 'GET',
        url: '/supertext-java/extraction/template/nlp/annotation/task/list/templateCode',
      },
    ],
  };
};

interface IGetTaggingListParams {
  parent_task_id: number;
  keyword?: string;
  status?: 0 | 1 | 2 | 3;
  mark_status?: 0 | 1 | 2 | 3;
  page?: number;
}
export const getTaggingList = (
  params: IGetTaggingListParams,
  signal?: AbortSignal,
) => {
  return request<IRes<IList<any>>>(
    '/supertext-java/extraction/template/nlp/task/tagging',
    { params, signal },
  );
};

getTaggingList.getQueryKey = () => {
  return {
    queryKey: [
      {
        method: 'GET',
        url: '/supertext-java/extraction/template/nlp/task/tagging',
      },
    ],
  };
};

export const createTaggingTask = (payload: {
  parent_id: number;
  module: 'TAGGING';
  file_hash_list: Array<{
    file_hash_id: string;
    task_name: string;
  }>;
}) => {
  return request<IRes<any>>(
    '/supertext-java/extraction/template/nlp/task_create/tagging',
    {
      data: payload,
      method: REQUEST_METHODS.post,
    },
  );
};

createTaggingTask.queryKey = {
  method: 'POST',
  url: '/supertext-java/extraction/template/nlp/task_create/tagging',
};

export const removeTasks = (payload: string[]) => {
  return request<IRes<any>>(
    '/supertext-java/extraction/template/batchDeleteTask',
    {
      method: REQUEST_METHODS.delete,
      data: payload,
    },
  );
};

export type * from './type';
